import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DeleteAccountModal } from './DeleteAccountModal';

export const AccountDangerZone = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { t } = useTranslation('profile');

  return (
    <>
      <Card className="border-red-200 bg-red-50/30">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-red-700">
            <AlertTriangle className="w-5 h-5" />
            {t('account.dangerZone', 'Danger Zone')}
          </CardTitle>
          <CardDescription className="text-red-600">
            {t('account.dangerZoneDescription', 'Irreversible and destructive actions')}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-4 border border-red-200 rounded-lg bg-white">
            <div>
              <h3 className="font-medium text-red-800">
                {t('account.deleteAccountTitle', 'Delete Account')}
              </h3>
              <p className="text-sm text-red-600 mt-1">
                {t('account.deleteAccountSubtitle', 'Permanently delete your account and all data. This action cannot be undone.')}
              </p>
            </div>
            <Button 
              variant="destructive"
              onClick={() => setIsDeleteModalOpen(true)}
              className="gap-2"
            >
              <Trash2 className="w-4 h-4" />
              {t('account.deleteAccount', 'Delete Account')}
            </Button>
          </div>

          <div className="text-xs text-red-500 bg-red-50 p-3 rounded-lg">
            <p className="font-medium mb-1">
              {t('account.gdprNotice', 'GDPR Data Protection Notice:')}
            </p>
            <p>
              {t('account.gdprText', 'You have the right to request deletion of your personal data. This action will permanently remove all your information from our systems in compliance with GDPR Article 17 (Right to Erasure).')}
            </p>
          </div>
        </CardContent>
      </Card>

      <DeleteAccountModal 
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      />
    </>
  );
};